import styled from 'styled-components'
import Footer from '../../components/footer/Footer'
import Header from '../../components/header/Header'
import { BiomarkersContainer, Container, Title } from '../recommendations/Recommendations'
import MeasuredBiomarkers from '../../components/measuredBiomarkers/MeasuredBiomarkers'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import { useNavigate } from 'react-router-dom'

const Block = styled.div`
  /* margin-top: 60px; */
  width: 100%;
`

const Main = () => {
    return (<div style={{maxWidth: '800px', margin: '0 auto'}}>
            <h1>Cookies Policy</h1>

            <h2>1. Introduction</h2>
            <p>At Swiss Medical Laboratory, we use cookies and similar technologies to ensure the functionality of our website and to enhance your browsing experience. This policy provides detailed information about how and when we use cookies.</p>

            <h2>2. What are Cookies?</h2>
            <p>Cookies are small text files that are placed on your device when you visit a website. These files often include an anonymous unique identifier, allowing websites to remember user actions and preferences over a period of time.</p>

            <h2>3. How We Use Cookies</h2>
            <p>We use cookies for several purposes:</p>
            <ul>
                <li><strong>Essential Cookies:</strong> These are required for the operation of our website. They include cookies that enable you to log into secure areas or use e-billing services.</li>
                <li><strong>Performance and Analytics Cookies:</strong> They allow us to recognize and count visitors, track page views, and understand user interactions. This helps us improve website functionality and user experience.</li>
                <li><strong>Functionality Cookies:</strong> These are used to recognize you when you return to our website, enabling us to personalize content for you and remember your preferences.</li>
                <li><strong>Targeting Cookies:</strong> These cookies record your visit to our website, the pages you visited, and the links you followed. We use this information to make our website and advertising more relevant to your interests.</li>
            </ul>

            <h2>4. Third-Party Cookies</h2>
            <p>We may also use third-party cookies to report usage statistics and deliver advertisements on and through our website. These organizations may combine information gathered from our site with information they have collected elsewhere.</p>

            <h2>5. Managing and Blocking Cookies</h2>
            <p>You can manage cookies through your browser settings. Most browsers allow you to block or delete cookies from your system. To learn more about browser settings, please consult your browser's help function. If you disable cookies, it may affect the functionality and features of our site.</p>

            <h2>6. Changes to This Policy</h2>
            <p>We may update our cookies policy from time to time. Any changes will be posted on this page, so please check back periodically to stay informed.</p>

            <h2>7. More Information</h2>
            <p>For further information on cookies, including how to see what cookies have been set on your device and how to manage and delete them, visit <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.</p>

            <h2>8. Contact</h2>
            <p>If you have any questions about our use of cookies or this policy, please contact us.</p>

        </div>
    )
}

export default Main
